import React from 'react';
import GriffInput from '../commons/GriffInput.jsx'
import SidebarFrame from "./SidebarFrame";

export default class GriffeSettings extends SidebarFrame {

    state = {}

    renderTitle() {
        return I18N("Griffe");
    }

    renderBody() {
        return (
            <div>
                <GriffInput value={APP.arrangement.griffArtikelnummer} setValue={APP.model.tryWrap(this,value=>APP.arrangement.griffArtikelnummer = value)}
                            label={I18N("Welche Griffe wünschen Sie?")}/>
            </div>
        )
    }
}